const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const shortcutReducer = (state = {}, action) => {
  switch (action.type) {
    case 'RESET_SHORTCUT_OBJ':
      return {}
    case 'RESET_SHORTCUT_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'SHORTCUT_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_SHORTCUTS':
      return {
        ...state,
        status: {
          get_shortcuts: {
            ...initialStatus,
            loading: true,
          },
        },
      }
    case 'SET_SHORTCUTS':
      return {
        ...state,
        shortcuts: [...action.payload],
        status: {
          get_shortcuts: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'ADD_SHORTCUT':
      return {
        ...state,
        status: {
          add_shortcut: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'ADDED_SHORTCUT':
      return {
        ...state,
        shortcuts: [...state.shortcuts, action.payload?.data],
        status: {
          add_shortcut: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'UPDATE_SHORTCUT':
      return {
        ...state,
        status: {
          update_shortcut: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'UPDATED_SHORTCUT':
      let updatedList = [...state.shortcuts]
      const index = updatedList.findIndex((el) => el.id === action?.payload?.id)
      updatedList[index] = { ...updatedList[index], ...action?.payload }

      return {
        ...state,
        shortcuts: updatedList,
        status: {
          update_shortcut: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'DELETE_SHORTCUT':
      return {
        ...state,
        status: {
          delete_shortcut: {
            ...initialStatus,
            loading: true,
            data: { id: action.payload },
          },
        },
      }
    case 'DELETED_SHORTCUT':
      let shortcuts = state.shortcuts.filter(
        (el) => el.id !== action?.payload?.id
      )
      return {
        ...state,
        shortcuts: shortcuts,
        status: {
          delete_shortcut: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }

    default:
      return state
  }
}

export default shortcutReducer
